import {ChangeDetectionStrategy, Component, Input, OnInit, ViewContainerRef} from '@angular/core';
import {FormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {map} from 'rxjs';

import {ResourceService} from 'src/app/services/resource.service';
import {UserService} from 'src/app/services/shared/user.service';
import {LocationDetailsResponse} from 'src/app/shared/models/LocationDetailsResponse.model';
import {UnitFullName} from 'src/app/shared/models/unit-bank-account/UnitFullName.model';
import {UnitPhone} from 'src/app/shared/models/unit-bank-account/UnitPhone.model';
import {UnitBusinessVirtualDebitCardDto} from 'src/app/shared/models/unit-card/UnitBusinessVirtualDebitCardDto.model';
import {TerraUtils} from 'src/app/shared/TerraUtils';
import {CustomValidators} from 'src/app/shared/validators/custom.validators';
import {AddressFields, AddressFormSettings} from '../../../address-form/address-form.settings';
import {CreateCardDialogComponent} from '../create-card-dialog/create-card-dialog.component';
import UnitAccountProvider from 'src/app/shared/enums/UnitAccountProvider.enum';
import TermType from 'src/app/shared/enums/TermsTypes.enum';

@Component({
  selector: 'terra-unit-card-holder-form',
  templateUrl: './unit-card-holder-form.component.html',
  styleUrls: ['./unit-card-holder-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitCardHolderFormComponent implements OnInit {

  @Input() businessCardDraft: UnitBusinessVirtualDebitCardDto = null;

  pageForm: UntypedFormGroup;
  readonly today = new Date();
  submit: boolean = false;
  termType = TermType;


  originalAddress$ = this.userService.accountDetails$
    .pipe(
      map(accountDetails => {
        if (!!this.businessCardDraft) {
          return TerraUtils.unitAddressToLocationObj(this.businessCardDraft.address, this.resourceService.allStates, this.resourceService.allCountries);
        }
        if (!!accountDetails.organizationDetails?.locationDetails && accountDetails.organizationDetails?.locationDetails?.countryId === 1) {
          return accountDetails.organizationDetails.locationDetails;
        } else if (!accountDetails.locationDetails && accountDetails.locationDetails?.countryId === 1) {
          return accountDetails.locationDetails;
        } else {
          return {
            countryId: 1
          } as LocationDetailsResponse;
        }
      })
    );

  unitAccountThreadProvider$ = this.userService.accountDetails$.pipe(
    // if no organization -> then also use thread
    map(acc => !!!acc.organizationDetails?.unitAccountProvider || (acc.organizationDetails?.unitAccountProvider === UnitAccountProvider.Thread))
  );

  constructor(
    private userService: UserService,
    private resourceService: ResourceService,
    private dialogRef: MatDialogRef<CreateCardDialogComponent>,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private vcr: ViewContainerRef,
  ) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  get addressFormSettings(): AddressFormSettings {
    // tslint:disable-next-line:no-bitwise
    const fieldsToShow = AddressFields.Country | AddressFields.Street | AddressFields.Street2 | AddressFields.City | AddressFields.State | AddressFields.PostalCode;
    const requireFields = AddressFields.Country | AddressFields.Street | AddressFields.City | AddressFields.State | AddressFields.PostalCode;
    return new AddressFormSettings(fieldsToShow, requireFields, true);
  }

  initForm() {
    this.pageForm = new UntypedFormGroup({
      firstName: new UntypedFormControl(this.businessCardDraft?.fullName?.first, [Validators.required]),
      lastName: new UntypedFormControl(this.businessCardDraft?.fullName?.last, [Validators.required]),
      email: new UntypedFormControl(this.businessCardDraft?.email, [Validators.required, Validators.email]),
      dateOfBirth: new UntypedFormControl(this.businessCardDraft?.dateOfBirth, [Validators.required]),
      phone: new UntypedFormControl(UnitPhone.toFormValue(this.businessCardDraft?.phone), [Validators.required, CustomValidators.InternationalPhoneNumber.bind(this)]),
      terms: new UntypedFormControl(null, [Validators.requiredTrue]),
      address: new UntypedFormControl(this.businessCardDraft?.address || {}),
    });
  }

  submitForm() {
    this.submit = true;
    if (this.pageForm.invalid) {
      return;
    }

    const model: UnitBusinessVirtualDebitCardDto = {
      id: this.businessCardDraft?.id || 0,
      email: this.pageForm.value.email,
      phone: UnitPhone.fromFormValue(this.pageForm.value.phone),
      fullName: new UnitFullName(this.pageForm.value.firstName, this.pageForm.value.lastName),
      dateOfBirth: this.pageForm.value.dateOfBirth,
      terms: this.pageForm.value.terms,
      address: TerraUtils.populateUnitAddress(this.pageForm.value.address, this.resourceService.allStates, this.resourceService.allCountries)

    } as UnitBusinessVirtualDebitCardDto;

    this.dialogRef.close(model);

  }
}
